import React, { useState } from "react";
import { AppButton } from "components/shared/AppButton";
import { downloadEcoSaltReport } from "hooks/useEcoSaltUpgrade";
import { notify } from "utils/notify";

/** Admin: downloads the temporary EcoSalt upgrade report (CSV). */
const EcoSaltReportButton: React.FC = () => {
  const [exporting, setExporting] = useState(false);
  const run = async () => {
    setExporting(true);
    try {
      await downloadEcoSaltReport();
    } catch {
      notify.error("Could not export the EcoSalt report");
    } finally {
      setExporting(false);
    }
  };
  return (
    <AppButton variant="ghost" onClick={() => void run()} disabled={exporting}>
      {exporting ? "Exporting..." : "EcoSalt report (CSV)"}
    </AppButton>
  );
};

export default EcoSaltReportButton;
